import { dynamicLoader } from '~/utils';

export const BidLogPage = dynamicLoader({
  name: 'BidLogPage',
  importFunc: () => import('./bid-log'),
});